import { addBulkGifteeBoxIssueConfigs } from '@common/api/graphql/addBulkGifteeBoxIssueConfigsGql';
import type { ApiError } from '@common/api/graphql/apolloClient';
import { createSuccessMessage } from '@common/api/graphql/successMessage';
import {
  addBulkGifteeBoxIssueConfigsFailure,
  addBulkGifteeBoxIssueConfigsStart,
  addBulkGifteeBoxIssueConfigsSuccess
} from '@console/actions/actions';
import type { AppThunkAction } from '@console/actions/thunkType';
import type { AddingBulkGifteeBoxIssueConfigs } from '@console/reducers/edit/project/gifteeBoxConfigs/addingBulkGifteeBoxIssueConfigs';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

export const addBulkGifteeBoxIssueConfigsSuccessThunk =
  (): AppThunkAction<Promise<void>> => dispatch => {
    dispatch(
      addBulkGifteeBoxIssueConfigsSuccess(createSuccessMessage('追加発注'))
    );
    return Promise.resolve();
  };

export const addBulkGifteeBoxIssueConfigsFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(addBulkGifteeBoxIssueConfigsFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const addBulkGifteeBoxIssueConfigsThunk =
  (
    gifteeBoxConfigUrlCode: UrlCode,
    addingBulkGifteeBoxIssueConfigs: AddingBulkGifteeBoxIssueConfigs
  ): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(addBulkGifteeBoxIssueConfigsStart());

    return addBulkGifteeBoxIssueConfigs(
      gifteeBoxConfigUrlCode,
      addingBulkGifteeBoxIssueConfigs
    )
      .then(() => dispatch(addBulkGifteeBoxIssueConfigsSuccessThunk()))
      .catch((error: ApiError) =>
        dispatch(addBulkGifteeBoxIssueConfigsFailureThunk(error))
      );
  };
